module.exports = __webpack_public_path__ + "static/media/header_slide_01.cd36882b.jpg";